import React from 'react';
import { CommunityAskFeed } from './CommunityAskFeed';

/** Ask RCM with the community channel selected: composer, then a voted feed. */
export function AskCommunityLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex-1 min-h-0 overflow-y-auto">
      <div className="mx-auto w-full max-w-[720px] px-4 pb-10 pt-6">
        {children}
        <CommunityAskFeed />
      </div>
    </div>
  );
}
